// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import App from "./App";
import Homepage from "./homepage";
import Layout from "./Layout";
import reportWebVitals from "./reportWebVitals";
import Map from "./Map";
import BuildingList from "./BuildingList";
import Profile from "./Profile";

function RequireAuth({ children }) {
  const authed = Boolean(localStorage.getItem("token"));
  return authed ? children : <Navigate to="/" replace />;
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />

        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/Homepage" element={<Homepage />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/Map" element={<Map />} />
          <Route path="/BuildingList" element={<BuildingList />} />
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
